import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useCallback } from 'sb-hooks'
import { constants, snowplow } from 'common/helpers'

import SMSButton from './SMSButton/SMSButton'
import CopyButton from './CopyButton/CopyButton'
import GmailButton from './GmailButton/GmailButton'
import FacebookButton from './FacebookButton/FacebookButton'

import s from './ShareButton.scss'


const buttonComponents = {
  sms: SMSButton,
  link: CopyButton,
  gmail: GmailButton,
  facebook: FacebookButton,
}

const ShareButton = ({ page, type, rounded }) => {
  const handleShareClick = useCallback((type) => {
    snowplow.track(constants.snowplowEvents.shareButtonClick, { type, page })
  }, [ page ])

  const ButtonComponent = buttonComponents[type]

  return Boolean(ButtonComponent) && React.createElement(ButtonComponent, {
    className: cx({ [s.rounded]: rounded }),
    rounded,
    onClick: () => handleShareClick(type),
  })
}


ShareButton.propTypes = {
  page: PropTypes.string.isRequired,
  type: PropTypes.oneOf([ 'sms', 'link', 'gmail', 'facebook' ]).isRequired,
  rounded: PropTypes.bool,
}

export default React.memo(ShareButton)
